<template>
  <div class="dashboard-budget-lider">
    <nav class="page-breadcrumb mb-1">
      <feather-icon icon="HomeIcon" size="14" />
      <span class="ml-25">Budget do Líder</span>
      <feather-icon icon="ChevronRightIcon" size="14" class="mx-25" />
      <span class="font-weight-bold">Dashboard</span>
    </nav>

    <div v-if="isLoading || carregando" class="text-center py-5"><b-spinner /></div>

    <template v-else-if="dashboard">
      <b-row>
        <b-col md="3" sm="6">
          <b-card class="text-center">
            <small class="text-muted d-block">Budgets</small>
            <h3 class="mb-0">{{ dashboard.resumo.budgets }}</h3>
            <small class="text-muted">{{ dashboard.resumo.vigentes }} vigentes</small>
          </b-card>
        </b-col>
        <b-col md="3" sm="6">
          <b-card class="text-center">
            <small class="text-muted d-block">Valor Total</small>
            <h3 class="mb-0">{{ formatarMoeda(dashboard.resumo.valor_total) }}</h3>
          </b-card>
        </b-col>
        <b-col md="3" sm="6">
          <b-card class="text-center">
            <small class="text-muted d-block">Gasto</small>
            <h3 class="mb-0 text-warning">{{ formatarMoeda(dashboard.resumo.gasto_total) }}</h3>
          </b-card>
        </b-col>
        <b-col md="3" sm="6">
          <b-card class="text-center">
            <small class="text-muted d-block">Saldo</small>
            <h3 class="mb-0" :class="dashboard.resumo.saldo_total <= 0 ? 'text-danger' : 'text-success'">
              {{ formatarMoeda(dashboard.resumo.saldo_total) }}
            </h3>
          </b-card>
        </b-col>
      </b-row>

      <b-card title="Por supervisor">
        <div v-if="!dashboard.porSupervisor || !dashboard.porSupervisor.length" class="text-muted">
          Nenhum budget do líder encontrado.
        </div>
        <b-table
          v-else
          :items="dashboard.porSupervisor"
          :fields="supFields"
          small
          responsive
          class="mb-0"
        >
          <template #cell(supervisor_nome)="data">
            {{ data.item.supervisor_nome || data.item.supervisorid }}
          </template>
          <template #cell(valor)="data">{{ formatarMoeda(data.item.valor) }}</template>
          <template #cell(valorgasto)="data">{{ formatarMoeda(data.item.valorgasto) }}</template>
          <template #cell(saldo)="data">
            <span :class="Number(data.item.saldo) <= 0 ? 'text-danger' : 'text-success'">
              {{ formatarMoeda(data.item.saldo) }}
            </span>
          </template>
        </b-table>
      </b-card>
    </template>

    <b-card v-else>
      <div class="text-center text-muted py-4">Sem dados para exibir.</div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BSpinner, BTable,
} from 'bootstrap-vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'DashboardBudgetLider',
  components: {
    BCard, BRow, BCol, BSpinner, BTable,
  },
  data() {
    return {
      carregando: true,
      supFields: [
        { key: 'supervisor_nome', label: 'Supervisor' },
        { key: 'budgets', label: 'Budgets', class: 'text-center' },
        { key: 'valor', label: 'Valor', class: 'text-right' },
        { key: 'valorgasto', label: 'Gasto', class: 'text-right' },
        { key: 'saldo', label: 'Saldo', class: 'text-right' },
      ],
    };
  },
  computed: {
    ...mapState('BudgetLider', ['dashboard', 'isLoading']),
  },
  async mounted() {
    this.carregando = true;
    try {
      await this.carregarDashboard();
    } finally {
      this.carregando = false;
    }
  },
  methods: {
    ...mapActions('BudgetLider', ['carregarDashboard']),
    formatarMoeda(v) {
      return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
};
</script>

<style scoped>
.page-breadcrumb {
  font-size: 0.85rem;
  color: #6e6b7b;
}
</style>
